import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {EventsService} from 'angular4-events';
import {Constants} from '../constants';
// import {PubSubService} from 'angular2-pubsub';


declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;
@Component({
  selector: 'app-cutomers',
  templateUrl: './cutomers.component.html',
  styleUrls: ['./cutomers.component.css']
})
export class CutomersComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  nao = new Nanobar();
  customerData: any;
  paggingControll: any;
  customerNameList = [];
  paginatedData: any;
  page = 0;
  last_page: any;
  once = false;
  paging_once = false;
  paging = false;
  limit: any;
  btnShowAfterLoad = false;
  pushReceive: any;
  searchCustomer = '';
  clearTimeout: any;
  filterValue = 'All';
  filterValCount = 0;
  noDataFoundSearch = false;
  type = 'data';
  defaultViewToShow = false;
  idval: any;
  id: number;
  constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router, private pubsub: EventsService, private events: EventsService) {
    // private pubsub: PubSubService
    this.dataService.pageName = 'customer listing';
    console.log('this.dataService.pageName', this.dataService.pageName);
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }

    this.idval = this.events.subscribe('customerDetailUpdateDone').subscribe((data) => {
      if ( data.page === 'customer' ) {
        console.log('data', data);
        $('.customerDetailListing').css('display', 'none');
        $('.customerListing').css('display', 'block');
        // setTimeout(() => {
        $('html').scrollTop(data.scroll);
        // },100);
      }
      // $('.intl-tel-input').remove();
    });
  }
  clearSearch() {
    this.searchCustomer = '';
    this.filterSearch();
  }
  customerslist() {
    this.nao.go(30);
    this.noDataFoundSearch = false;
    this.type = 'data';
    this.customerData = [];
    console.log('login data');
    this.dataService.getCustomersList(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        console.log('customer data', data);
        this.customerData = data;
        console.log('customer', data);
        if (this.customerData.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.customerData.rest_error_code === 2) toastr.error('Please login again');
        if (this.customerData.rest_error_code === 4) toastr.error('Doest not exist');
        this.last_page = this.customerData.last_page;
        this.customerData = this.customerData.items;
        if(this.customerData.length === 0) {
           this.defaultViewToShow = true;
        }
        this.btnShowAfterLoad = true;
        // this.limit = 2;
        console.log('this.last_page', this.last_page);
        this.page++;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getCustomersListByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getCustomersListByPage(window.localStorage.getItem('token'), this.page).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedData = data;
        // this.limit = this.paginatedData.limit;
        this.last_page = this.paginatedData.last_page;
        this.paginatedData = this.paginatedData.items;
        console.log('paginated before concat data', this.paginatedData);
        this.page++;
        // this.paging = false;
        // this.once = false;
        // this.paging_once = false;
        for (var i = 0; i < this.paginatedData.length; i++) {
          this.customerData.push(this.paginatedData[i]);
        }
        // this.customerData = this.customerData.concat(this.paginatedData.items);
        console.log('paginated concat data', this.customerData);
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
   filterValUpdate(val) {
    this.filterValue = val;
    if (val === 'All') {
      this.filterValCount = 0;
      this.filterSearch();
    }
    if (val === 'USA') {
      this.filterValCount = 1;
      this.filterSearch();
    }
  }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    this.noDataFoundSearch = false;
    this.type = 'search';
    this.page = 0;
    // if (this.searchCustomer === '') {
    //   this.customerslist();
    //   return;
    // }
    this.nao.go(30);
    console.log('login data');
    this.dataService.searchCustomersWithFilter(window.localStorage.getItem('token'), this.searchCustomer, this.filterValCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.customerData = [];
        this.customerData = data;
        this.last_page = this.customerData.last_page;
        this.page++;
        this.customerData = this.customerData.items;
        if (this.customerData.length === 0) {
          this.noDataFoundSearch = true;
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
  getCustomerDetailListing(id){
    var scroll = $(window).scrollTop();
    var data = {'id': id, 'page': 'customer', 'scroll': scroll};
    this.events.publish('customerId', data);
   $('.customerListing').css('display', 'none');
    setTimeout(() => {
      $('.customerDetailListing').css('display', 'block');
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number

      if(this.id != null && this.id != undefined) {
        if(isNaN(this.id) === false) {
          this.getCustomerDetailListing(this.id);
        }
      }
    });
    $('.customerDetailListing').css('display', 'none');
    this.customerslist();
    this.pushReceive = this.pubsub.subscribe('detectChange').subscribe((data) => {
      console.log('push data new_customer', data);
            if (data === 'new_customer') {
            this.customerslist();
            }
        });
    // $(window).scrollTop(0);
    // document.body.scrollTop = 0;
    // this.router.events.subscribe((evt) => {
    //         if (!(evt instanceof NavigationEnd)) {
    //             return;
    //         }
    //         window.scrollTo(0, 0);
    //     });
    var context = this;
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
      $('#customer').css('color', '#d77229');
     // $(window).scroll(function () {
     //   if(context.dataService.pageName === 'customer listing') {
     //       if(parseInt($(window).scrollTop()) + parseInt($(window).height()) > parseInt($(document).height()) - 10) {
     //                if (context.last_page !== true) {
     //                    context.paging = true;
     //                    if (!context.paging_once) {
     //                        context.paging_once = true;
     //                        context.getCustomersListByPageFunction();
     //                    }
     //                }
     //            } else {
     //                if (context.once) {
     //                    context.paging = false;
     //                    context.once = true;
     //                }
     //            }
     //            }
     //  });
  }

}



// WEBPACK FOOTER //
// ./src/app/cutomers/cutomers.component.ts